import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoDulce,
} from '../actions/ultimoDulce';


export const UltimoDulceReducerNodo = createSlice({
    name: 'ultimoDulce',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoDulce.pending, (state) => { state.loading = true })
            .addCase(ultimoDulce.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoDulce.rejected, (state) => { state.loading = false })
    }
})

export default UltimoDulceReducerNodo.reducer;
